import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Redirect } from 'react-router-dom';
import ErrorToast from '../ErrorToast';
import {
  UnrecoverableErrorModel,
  ToastErrorModel,
  RedirectErrorModel,
} from '../../models';

const ErrorHandler = ({
  unrecoverable,
  redirect,
  errors,
  children,
  dismiss,
  closeToast,
}) => {
  useEffect(() => {
    if (unrecoverable) {
      dismiss(unrecoverable);
    }
    if (redirect) {
      dismiss(redirect);
    }
  }, [unrecoverable, redirect, dismiss]);

  return (
    <>
      {unrecoverable && <Redirect to={{ pathname: '/unrecoverable_error' }} />}
      {redirect && <Redirect to={{ pathname: redirect.routeId }} />}
      {children}
      {errors[0] && <ErrorToast error={errors[0]} close={closeToast} />}
    </>
  );
};

ErrorHandler.propTypes = {
  closeToast: PropTypes.func.isRequired,
  dismiss: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.oneOfType([
      UnrecoverableErrorModel,
      ToastErrorModel,
      RedirectErrorModel,
    ])
  ),
  redirect: RedirectErrorModel,
  unrecoverable: PropTypes.object,
};

export default ErrorHandler;
